import { bindUrl, request } from "./request";

/**
 * 客户企业列表
 */
export function companyList() {
  return request({
    url: bindUrl("/oil/app/company/list", {}),
    method: "GET"
  });
}

/**
 * 新增企业激活验证码获取
 */
export function createCodeFetch(bodyParams) {
  return request({
    url: bindUrl("/oil/app/company/create/codeFetch", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 企业确认激活
 */
export function companyActive(bodyParams) {
  return request({
    url: bindUrl("/oil/app/company/active/confirm", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 客户企业详情
 */
export function companyDetail(queryParams) {
  return request({
    url: bindUrl("/oil/app/company/detail", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 获取已激活银行卡的企业列表
 */
export function activeBankCompanyList() {
  return request({
    url: bindUrl("/oil/app/company/activeBankCompanyList", {}),
    method: "GET"
  });
}

/**
 * 获取已激活的企业列表
 */
export function activeCompanyList() {
  return request({
    url: bindUrl("/oil/app/company/activeCompanyList", {}),
    method: "GET"
  });
}

/**
 * 获取企业银行卡列表
 */
export function companyBankCardList(bodyParams) {
  return request({
    // url: bindUrl("/oil/app/company/bank/list", {}),
    url: bindUrl("/svc-lss/bank/company/account/list", {}),
    method: "POST",
    data: bodyParams
  });
}

export function getCompanyDetail(queryParams) {
  return request({
    url: bindUrl("/svc-abns/company/detail", {}),
    method: "GET",
    params: queryParams
  });
}

// export function getCompanyDetail(queryParams) {
//   return request({
//     url: bindUrl("/svc-abns/company/detailById", {}),
//     method: "GET",
//     params: queryParams
//   });
// }

export function getUrl(queryParams) {
  return request({
    url: bindUrl("/svc-abns/company/authentication/url", {}),
    method: "GET",
    params: queryParams
  });
}

export function companySubmit(bodyParams) {
  return request({
    // url: bindUrl("/oil/app/company/bank/list", {}),
    url: bindUrl("/svc-abns/company/submit", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 企业银行卡绑卡认证金额获取
 */
export function companyBankBind(bodyParams) {
  return request({
    url: bindUrl("/oil/app/company/bank/bind", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 企业银行卡确认绑卡
 */
export function companyBankconfirmBind(bodyParams) {
  return request({
    url: bindUrl("/oil/app/company/bank/confirmBind", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 获取企业已激活银行卡列表
 */
export function companyBankActiveList(queryParams) {
  return request({
    url: bindUrl("/oil/app/company/bank/activeList", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 获取公司账户余额
 */
export function companyAccountBalance(queryParams) {
  return request({
    url: bindUrl("/oil/app/company/accountBalance", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 公司框架协议上传确认
 */
export function companyFrameworkUpload(bodyParams) {
  return request({
    url: bindUrl("/oil/app/company/framework/upload", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 公司信息修改
 */
export function companyModify(bodyParams) {
  return request({
    url: bindUrl("/oil/app/company/modify", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * e签宝地址获取
 */
export function authenticationUrl(bodyParams) {
  return request({
    url: bindUrl("/oil/app/company/authentication/url", {}),
    method: "POST",
    data: bodyParams
  });
}

export function bankCompanyCreate(bodyParams) {
  return request({
    url: bindUrl("/svc-lss/bank/company/create", {}),
    method: "POST",
    data: bodyParams
  });
}

export function bankList(bodyParams) {
  return request({
    url: bindUrl("/svc-lss/shb/bank/list", {}),
    method: "POST",
    data: bodyParams
  });
}

export function companyComplete(bodyParams) {
  return request({
    url: bindUrl("/svc-lss/shb/company/info/complete", {}),
    method: "POST",
    data: bodyParams
  });
}

export function companyReCreate(bodyParams) {
  return request({
    url: bindUrl("/svc-lss/shb/company/account/reCreate", {}),
    method: "POST",
    data: bodyParams
  });
}
